export const initialState = {
  title: 'BlockX Labs'
};

const app = (state = initialState) => state;

export default app;
